exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{padding:0;margin:0}body,button,input,select{font-family:Oswald,sans-serif}h1,h2,h3,h4,h5,h6{font-family:Pirata One,sans-serif}input,pre{font-family:PT Mono,monospace}h1,h2,h3,h4,h5,h6{font-weight:400;margin:0}.jumbotron{box-shadow:0 0 14px 0 rgba(0,0,0,.75);background:#000;padding-top:5px;padding-bottom:5px;color:#fff}.jumbotron p{margin:0;margin-bottom:5px}.jumbotron h1{background:#fff;-webkit-text-fill-color:transparent;-webkit-background-clip:text;text-shadow:0 0 hsla(0,0%,100%,.5);font-size:60px;color:#fff;margin:0}.root{background-attachment:fixed}.wrap{margin:0 auto;max-width:800px;padding-bottom:100px}.contain{padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe9bc386","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 23
// module chunks = 0